import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonIcon from '../../../../components/buttons/ButtonIcon';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { TrashOutlineIcon, AddIcon } from '../../../../components/buttons/IconButtons';
import ConnectorToggle from './ConnectorToggle';
import RuleRow from './RuleRow';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const RuleGroup = ({
    group,
    attributesFilter,
    onDeleteGroup,
    onAddRule,
    onDeleteRule,
    onRuleConnectorChange,
    onFieldChange,
    onConditionChange,
    onValueChange,
    onDateChange,
    onFromDateChange,
    onToDateChange,
    onFromValueChange,
    onToValueChange,
    onAssignMultiple,
    onValidityChange,
}) => {
    const { t } = useTranslation();

    return (
        <div className="border-full-primary-400 border-radius-8px">
            <div className="p-3 d-flex justify-content-between align-items-start background-primary-50 border-radius-top-8px border-bottom-primary-400">
                <div>
                    <p className="fs-14px ibl-font-w-600 font-color-general-950 mb-0">
                        {t('rule_group')}
                    </p>
                    <p className="fs-12px font-color-shades-600 mt-1 mb-0">
                        {t('combine_rules_in_group')}
                    </p>
                </div>
                <ButtonIcon
                    id={`btn_rg_del_group_${group.id}`}
                    Icon={TrashOutlineIcon}
                    onClick={onDeleteGroup}
                    title=""
                    className="btn-outlined-error-600 w-40px h-40px minw-40px p-0"
                    iconProps={'btn-icon-svg-18px'}
                />
            </div>
            <div className={"p-3"}>
                {group.rules.map((rule, ri) => (
                    <React.Fragment key={rule.id}>
                        {ri > 0 && (
                            <ConnectorToggle
                                connector={rule.connector}
                                onChange={(c) => onRuleConnectorChange(rule.id, c)}
                            />
                        )}
                        <RuleRow
                            t={t}
                            rule={rule}
                            attributesFilter={attributesFilter}
                            showDelete={group.rules.length > 1}
                            onDelete={() => onDeleteRule(rule.id)}
                            onFieldChange={(fId) => onFieldChange(rule.id, fId)}
                            onConditionChange={(cId, opKey) => onConditionChange(rule.id, cId, opKey, rule)}
                            onValueChange={(val) => onValueChange(rule.id, val)}
                            onDateChange={(date) => onDateChange(rule.id, date)}
                            onFromDateChange={(date) => onFromDateChange(rule.id, date)}
                            onToDateChange={(date) => onToDateChange(rule.id, date)}
                            onFromValueChange={(val) => onFromValueChange(rule.id, val)}
                            onToValueChange={(val) => onToValueChange(rule.id, val)}
                            onAssignMultiple={(selectedIds) => onAssignMultiple(rule.id, selectedIds, rule)}
                            onValidityChange={(field, val) => onValidityChange(rule.id, field, val)}
                        />
                    </React.Fragment>
                ))}

                <div className="mt-2">
                    <ButtonAction
                        id={`btn_rg_add_rule_group_${group.id}`}
                        name="add_rule"
                        className="btn-secondary-600"
                        Icon={AddIcon}
                        splitName={false}
                        onClick={onAddRule}
                        disabled={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default RuleGroup;
